/**
 * Polling service for real-time updates
 * Manages periodic API calls to keep room state synchronized
 */

export class PollingService {
  private intervalId: number | null = null;
  private readonly DEFAULT_INTERVAL = 3000; // 3 seconds as specified in requirements

  /**
   * Start polling with a callback function
   * @param callback - Function to call on each poll interval
   * @param intervalMs - Polling interval in milliseconds (defaults to 3 seconds)
   */
  start(callback: () => Promise<void>, intervalMs?: number): void {
    // Stop any existing polling first
    this.stop();

    const interval = intervalMs ?? this.DEFAULT_INTERVAL;
    
    // Execute callback immediately on start
    callback().catch(error => {
      console.warn('Polling callback failed:', error);
    });

    // Set up recurring polling
    this.intervalId = window.setInterval(() => {
      callback().catch(error => {
        console.warn('Polling callback failed:', error);
      });
    }, interval);
  }

  /**
   * Stop polling
   */
  stop(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  /**
   * Check if polling is currently active
   * @returns true if polling is active, false otherwise
   */
  isActive(): boolean {
    return this.intervalId !== null;
  }
}

// Export singleton instance
export const pollingService = new PollingService();